import { useMemo } from 'react';

import Character from './Character';
import { buildConfetti, Confetti, getDanceForIndex } from './helpers';

function StarMedal() {
  return (
    <svg width="88" height="100" viewBox="0 0 90 100" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="topPerfStarGrad" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#FFE089" />
          <stop offset="50%" stopColor="#F9C151" />
          <stop offset="100%" stopColor="#BB402A" />
        </linearGradient>
      </defs>
      <path
        d="M 45 10 L 54 36 L 82 36 L 60 53 L 68 80 L 45 64 L 22 80 L 30 53 L 8 36 L 36 36 Z"
        fill="url(#topPerfStarGrad)"
        stroke="#8B6914"
        strokeWidth="1.5"
      />
      <ellipse cx="34" cy="32" rx="4" ry="8" fill="#FFFFFF" opacity="0.5" />
    </svg>
  );
}

// Third rotating frame on the championship celebration: the single user
// (across all teams) who racked up the most user_total_points across
// every round of this tournament.
export default function TopPerformer({ userName, totalPoints }) {
  const confetti = useMemo(() => buildConfetti(60), []);
  const characters = [{ id: 'top-performer' }];
  const accentColor = '#F9C151';

  return (
    <>
      <Confetti pieces={confetti} />
      <div className="celebration-header">
        <div className="celebration-kicker" style={{ color: accentColor }}>⭐ Top Performer ⭐</div>
        <div style={{ display: 'inline-block', marginBottom: '16px' }}>
          <StarMedal />
        </div>
        <h1 className="celebration-title">Highest Points</h1>
        <div
          className="celebration-team-pill"
          style={{ background: '#FFFFFF', color: '#2F4166', border: `2px solid ${accentColor}` }}
        >
          {totalPoints != null
            ? `${totalPoints.toLocaleString()} points`
            : (userName || 'Top Performer')}
        </div>
        <div className="celebration-subtitle">
          {userName
            ? `${userName} — high-scorer of the tournament.`
            : 'The high-scorer of the tournament.'}
        </div>
      </div>

      <div
        className={`celebration-characters-grid ${characters.length >= 8 ? 'grid-cap-8' : ''}`}
      >
        {characters.map((player, i) => (
          <div
            key={player.id}
            className="celebration-character-cell"
            style={{ animationDelay: `${0.2 + i * 0.08}s` }}
          >
            <Character
              color={accentColor}
              dance={getDanceForIndex(i)}
              pose="crown"
              teamName={userName || ''}
              showFlag
              size="large"
            />
          </div>
        ))}
      </div>
    </>
  );
}
